export async function ssoAutoLogin(suite_token, login_hint, user_name, user_role) {
  try {
    const baseUrl = process.env.NODE_ENV === "development" ? "http://localhost:5000" : (process.env.REACT_APP_API_URL || "");
    const res = await fetch(`${baseUrl}/api/auth/sso-login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ suite_token, login_hint, user_name, user_role }),
    });
    
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      throw new Error(errorData.error || "SSO Login failed");
    }

    const data = await res.json();
    return data; // { user, token }
  } catch (error) {
    console.error("ssoAutoLogin error:", error);
    throw error;
  }
}

